import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import PanelHeader from './PanelHeader'

/**
 * Panel (Figma 66:13964): surface gradient + border/default + radius/md, gồm Panel Header và Body.
 * `elevation`: "docked" = nằm trong layout trang (vd. Navigator); "floating" = nổi trên map, thêm Shadow/Card (vd. AOI Management).
 * Header chỉ render khi có `title` / `icon` / `action` / `onClose`. Kích thước do nơi dùng quyết định qua `sx` (Figma mẫu: 296×480).
 */
const Panel = React.forwardRef(
  ({ title, icon, action, onClose, closeIcon, closeLabel, elevation = 'docked', children, sx, bodySx, ...props }, ref) => (
    <Box
      ref={ref}
      component="section"
      sx={[
        {
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: 'var(--space-16)',
          px: 'var(--space-0)',
          py: 'var(--space-16)',
          overflow: 'hidden',
          backgroundImage: 'linear-gradient(to bottom, var(--color-navy-850), var(--color-navy-950))', // Gradient/Surface
          border: 'var(--stroke-default) solid var(--color-border-default)',
          borderRadius: 'var(--radius-md)'
        },
        elevation === 'floating' && { boxShadow: '4px 4px 16px 0 rgba(0, 0, 0, 0.3)' }, // Shadow/Card
        ...(Array.isArray(sx) ? sx : [sx])
      ]}
      {...props}
    >
      {(title || icon || action || onClose) && (
        <PanelHeader title={title} icon={icon} action={action} onClose={onClose} closeIcon={closeIcon} closeLabel={closeLabel} />
      )}
      <Box sx={[{ position: 'relative', flex: '1 0 0', minHeight: 0, width: '100%' }, ...(Array.isArray(bodySx) ? bodySx : [bodySx])]}>
        {children}
      </Box>
    </Box>
  )
)

Panel.displayName = 'Panel'

Panel.propTypes = {
  title: PropTypes.node,
  icon: PropTypes.string,
  action: PropTypes.node,
  onClose: PropTypes.func,
  closeIcon: PropTypes.string,
  closeLabel: PropTypes.string,
  elevation: PropTypes.oneOf(['docked', 'floating']),
  children: PropTypes.node,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  bodySx: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
}

export { PanelHeader }
export default Panel
